// src/context/ThemeContext.jsx
// Class-based dark mode with localStorage, matching the marketing site.

import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ isDarkMode: false, toggle: () => {} });

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    let saved = null;
    try { saved = localStorage.getItem("cb-theme"); } catch (e) {}
    const dark = saved
      ? saved === "dark"
      : window.matchMedia("(prefers-color-scheme: dark)").matches;
    setIsDarkMode(dark);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
    try { localStorage.setItem("cb-theme", isDarkMode ? "dark" : "light"); } catch (e) {}
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggle: () => setIsDarkMode((v) => !v) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
